function executeGet(path, data) {
  return $.ajax({
    url : PUBLIC_API_SERVER + path,
    type : 'GET',
    data: data,
    headers : {
      'X-User-UUID' : USER_UUID
    },
    dataType : 'json'
  });
};

function executeDelete(path, body) {
  return $.ajax({
    url : PUBLIC_API_SERVER + path,
    type : 'DELETE',
    data : body ? JSON.stringify(body) : undefined,
    headers : {
      'X-User-UUID' : USER_UUID
    },
    contentType: "application/json; charset=utf-8",
    dataType : 'json',
  });
};

function executePost(path, body) {
  return $.ajax({
    url : PUBLIC_API_SERVER + path,
    type : 'POST',
    data : JSON.stringify(body),
    headers : {
      'X-User-UUID' : USER_UUID
    },
    processData : false,
    contentType: "application/json; charset=utf-8",
    dataType : 'json'
  });
}
